import { useCallback, useEffect, useMemo, useState } from "react";
import { getIsAgeVerificationNotExpired } from "@jti/fe-common";
import { AGE_VERIFICATION_METHOD } from "../../components/HardAgeVerificationPopup/HardAgeVerificationPopup.types";
import { useUser } from "../useUser";
const getIsPageContainRoute = (route) => window.location.href.includes(route);
export const useHavOverlayConditions = ({ ignoreUrls, ageVerificationMethod }) => {
    const isRegisterPage = getIsPageContainRoute("/register");
    const isAgeVerificationNotExpired = getIsAgeVerificationNotExpired();
    const { isUserLoggedIn, user } = useUser();
    const getIsRouteInIgnoreList = useCallback(() => ignoreUrls.some((skipHavUrl) => window.location.href.includes(skipHavUrl)), [ignoreUrls]);
    const [isRouteInIgnoreList, setIsRouteInIgnoreList] = useState(getIsRouteInIgnoreList());
    const isPassAvMethod = ageVerificationMethod === AGE_VERIFICATION_METHOD.PASS;
    const isUserAgeVerified = isUserLoggedIn && user.is_age_verified;
    const isUserNotSet = (isUserLoggedIn && user.email === "") || user === null;
    const shouldHidePass = (isPassAvMethod && isUserAgeVerified) || isUserNotSet || isRouteInIgnoreList;
    const shouldRenderHAV = !isAgeVerificationNotExpired && !shouldHidePass;
    useEffect(() => {
        const handleHashChange = () => {
            setIsRouteInIgnoreList(getIsRouteInIgnoreList());
        };
        // NOTE: This is needed for cases when user is redirected in one fragment scope
        window.addEventListener("hashchange", handleHashChange);
        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);
    const shouldTriggerAv = useMemo(() => isRegisterPage && isPassAvMethod, [isPassAvMethod, isRegisterPage]);
    return { shouldRenderHAV, shouldTriggerAv, isRegisterPage };
};
//# sourceMappingURL=useHavOverlayConditions.js.map